import {fetchBody, URL_ADD_MANAGEMENTPROMPT, URL_GET_MANAGEMENTPROMPT, URL_GET_SYSTEMPROMPT, URL_ADD_SYSTEMPROMPT, URL_GET_BANKNAME} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";


export const addSystemPrompt = ({mReqSystemPrompt, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqSystemPrompt, token}), 
      url: URL_ADD_SYSTEMPROMPT, 
      success:(jsonData)=>{
        //var menu = analysisMenu(jsonData.menus);
        console.log(jsonData)
        return jsonData
      }, 
      failure:(err)=>{
        return err
      }
    })
  }
  return;
}

export const getSystemPrompt = ({pageId, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({
        body: {pageId},
        token}), 
      url: URL_GET_SYSTEMPROMPT, 
      success:(jsonData)=>{
        //var menu = analysisMenu(jsonData.menus);
        //console.log(jsonData)
        if(success !== undefined)
          success(jsonData.mReqSystemPrompt)
        return jsonData.mReqSystemPrompt
      }, 
      failure:(err)=>{
        return err
      }
    })
  }
}


export const addManagementPrompt = ({mReqSystemPrompt, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqSystemPrompt, token}), 
      url: URL_ADD_MANAGEMENTPROMPT, 
      success:(jsonData)=>{
        //var menu = analysisMenu(jsonData.menus);
        console.log(jsonData)
        return jsonData
      }, 
      failure:(err)=>{
        return err
      }
    })
  }
  return;
}

export const getManagementPrompt = ({pageId, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({
        body: {pageId},
        token}), 
      url: URL_GET_MANAGEMENTPROMPT, 
      success:(jsonData)=>{
        //var menu = analysisMenu(jsonData.menus);
        //console.log(jsonData)
        if(success !== undefined)
          success(jsonData.mReqSystemPrompt)
        return jsonData.mReqSystemPrompt
      }, 
      failure:(err)=>{
        return err
      }
    })
  }
}

export const api_getBankName = ({bankCode, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({
        body: {bankCode},
        token}), 
      url: URL_GET_BANKNAME, 
      success:(jsonData)=>{
        success(jsonData.bankName) 
      }, 
      failure:(err)=>{
        failure(err)
      }
    })
  }
}
